/**
 * Shared text utilities for PCC event data.
 *
 * cleanTitle() is the SINGLE source of truth for title cleaning on the frontend.
 * Acts as a safety net — titles SHOULD already be clean from the backend,
 * but this catches any edge cases.
 */

/**
 * Clean and normalize an event title.
 * Mirrors the backend utils/text.py clean_title() function.
 *
 * @param {string} t - Raw title string
 * @returns {string} Cleaned title
 */
export function cleanTitle(t) {
  if (!t) return '';

  let s = t;

  // 1. Decode common HTML entities
  s = s
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&eacute;/g, 'é')
    .replace(/&egrave;/g, 'è')
    .replace(/&agrave;/g, 'à')
    .replace(/&ecirc;/g, 'ê')
    .replace(/&ocirc;/g, 'ô')
    .replace(/&ucirc;/g, 'û')
    .replace(/&iuml;/g, 'ï')
    .replace(/&ccedil;/g, 'ç');

  // 2. Remove zero-width / invisible Unicode chars
  s = s.replace(/[\u200B\u200C\u200D\u200E\u200F\uFEFF\u00AD]/g, '');

  // 3. Collapse whitespace
  s = s.replace(/\s+/g, ' ').trim();

  // 3b. Fix broken spaces INSIDE words before accented chars.
  //     e.g. "Conf érence" → "Conférence", "Pri ère" → "Prière".
  //     Lookahead requires another letter after, so standalone prepositions
  //     ("à Paris", "café à emporter") are preserved.
  s = s.replace(/([a-zA-Z])\s([éèêëàâîïôûùüç])(?=[a-zA-Zéèêëàâîïôûùüç])/g, '$1$2');

  // 4. Fix camelCase: lowercase (including accented) followed by UPPERCASE (including accented)
  //    lowercase range: a-z + U+00E0-U+00F6 + U+00F8-U+00FF
  //    uppercase range: A-Z + U+00C0-U+00D6 + U+00D8-U+00DE
  s = s.replace(/([a-z\u00E0-\u00F6\u00F8-\u00FF])([A-Z\u00C0-\u00D6\u00D8-\u00DE])/g, '$1 $2');

  // 5. Capitalize first letter
  if (s) s = s[0].toUpperCase() + s.slice(1);

  return s;
}
